import format from 'date-fns/format';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import history from './history';
import Scroll from 'react-scroll';
import sanitizeHtml from 'sanitize-html';
import root from 'window-or-global';
// import scrollToElement from 'scroll-to-element';

function upperCaseString (match, group) {
  // TODO this method now has a side effect. Fix that.
  // upper case only when text preceding the _ is a character and not a number
  if (Number(group) >= 0 || Number(group) <= 9) {
    return `_${group}`;
  }
  return group.toUpperCase();
}

export function camelCaseString (str) {
  return str.replace(/_(.)/g, upperCaseString);
}

function camelCaseKeysInObject (obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let camelCasedKey = camelCaseString(key);
      if (camelCasedKey !== key) {
        obj[camelCasedKey] = obj[key];
        delete obj[key];
      }

      if (typeof obj[camelCasedKey] === 'object') {
        if (Array.isArray(obj[camelCasedKey])) {
          obj[camelCasedKey] = camelCaseKeysInArray(obj[camelCasedKey]);
        } else {
          obj[camelCasedKey] = camelCaseKeysInObject(obj[camelCasedKey]);
        }
      }
    }
  }

  return obj;
}

function camelCaseKeysInArray (arr) {
  return arr.map(elem => camelCaseKeysInObject(elem));
}

// utility method that accept an array of objects or an object or an object with one or more elements being array
// returns their keys camelCased
export function camelCaseKeys (data) {
  if (Array.isArray(data)) {
    return camelCaseKeysInArray(data);
  }

  const nestedCamelCasedData = Object.keys(data).reduce((config, datum) => {
    if (Array.isArray(data[datum])) {
      config[datum] = camelCaseKeysInArray(data[datum]);
    }
    else {
      config[datum] = camelCaseKeysInObject(data[datum]);
    }

    return config;
  }, {});

  return camelCaseKeysInObject(nestedCamelCasedData);
}

export function getCookie (name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== '') {
      var cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
          let cookie = cookies[i].trim();
          // Does this cookie string begin with the name we want?
          if (cookie.substring(0, name.length + 1) === (name + '=')) {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
              break;
          }
      }
  }
  return cookieValue;
}

export function generateFormDataForJSON (json) {
  const supportsFormData = root.FormData !== undefined;
  let data = supportsFormData ? new FormData() : '';
  Object.keys(json).filter((key) => {
    return json[key] !== null;
  }).forEach((key) => {
    if ( Array.isArray(json[key]) ) {
      let valueArray = json[key];
      valueArray.forEach((k) => {
        if (supportsFormData) {
          data.append(`${key}`, k);
        } else {
          data = `${data}${key}=${k}&`;
        }
      });
    } else if (typeof json[key] === 'object' && json[key].name) {
      // TODO not supporting IE9 for file upload
      if (supportsFormData) {
        data.append(`${key}`, json[key], json[key].name);
      }
    } else {
      if (supportsFormData) {
        data.append(`${key}`, json[key]);
      } else {
        data = `${data}${key}=${json[key]}&`;
      }
    }
  });

  return data;
}

export function snakeCaseKeys (data) {
  if (Array.isArray(data)) {
    throw Error('snakeCaseKeys doesn\'t support arrays for now');
  }

  return Object.keys(data).reduce((snakeCased, datum) => {
    let snakedCasedKey = datum.replace(/([A-Z])/g, function($1) { return '_' + $1.toLowerCase(); } );
    snakeCased[snakedCasedKey] = data[datum];
    return snakeCased;
  }, {});
}

export const getFormattedDate = dateString =>
  format(dateString, 'MMM DD, YYYY');

export const getFormattedDateWithTime = dateString =>
  format(dateString, 'MMM DD, YYYY [at] h:mma');

export function getUrlParameterByName(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results;
  try {
    results = regex.exec(root.location.search);
  } catch (e) {
    results = null;
  }
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/*
 * https://github.com/rackt/react-router/blob/master/modules/PatternUtils.js
 * using the code to match the url pattern
 */

function escapeRegExp (string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function escapeSource (string) {
  return escapeRegExp(string).replace(/\/+/g, '/+');
}

function _compilePattern (pattern) {
  let regexpSource = '';
  const paramNames = [];
  const tokens = [];

  let match, lastIndex = 0, matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*|\(|\)/g;
  while ((match = matcher.exec(pattern))) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeSource(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/?#]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '*') {
      regexpSource += '([\\s\\S]*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeSource(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern,
    regexpSource,
    paramNames,
    tokens,
  };
}

const CompiledPatternsCache = {};

export function compilePattern (pattern) {
  if (!(pattern in CompiledPatternsCache)) {
    CompiledPatternsCache[pattern] = _compilePattern(pattern);
  }

  return CompiledPatternsCache[pattern];
}

export function matchPattern (pattern, pathname) {
  let { regexpSource, tokens } = compilePattern(pattern);
  regexpSource += '/*'; // Ignore trailing slashes

  const captureRemaining = tokens[tokens.length - 1] !== '*';

  if (captureRemaining) {
      regexpSource += '([\\s\\S]*?)';
  }
  const match = pathname.match(new RegExp('^' + regexpSource + '$', 'i'));

  if (match != null) {
    return true;
  } else {
    return false;
  }
}

export function addTrailingSlashToUrl (input = '') {
  if (input.substring(input.length - 1) === '/') {
    return input;
  } else {
    return `${input}/`;
  }
}

export function getCurrentLocationPathname () {
  return addTrailingSlashToUrl(history ? history.location.pathname : '');
}

export const getPathname = () => {
  return removeTrailingSlash(history ? history.location.pathname : '');
};

export function getFullName ({ username, firstName, lastName, name }) {
  if( firstName || lastName ) {
    return `${ firstName ? firstName : ''} ${ lastName ? lastName : '' }`;
  } else if (name) {
    return name;
  } else {
    return username;
  }
}

export const objectWithout = (obj, keys) => {
  let copiedObj = { ...obj };
  if (!Array.isArray(keys)) {
    keys = [keys];
  }

  keys.forEach((key) => {
    delete copiedObj[key];
  });

  return copiedObj;
};

export function rupees(x = 0) {
  if(!x){
    return 0;
  }
  x = x % 1 !== 0 ? Number(x).toFixed(2) : Number(x).toString();
  let afterPoint = '';
  if (x.indexOf('.') > 0) {
    afterPoint = x.substring(x.indexOf('.'), x.length);
  }
  x = x >= 0 ? Math.floor(x) : Math.ceil(x);
  x = x.toString();
  let lastThree = x.substring( x.length - 3 );
  let otherNumbers = x.substring( 0, x.length - 3 );
  if ( otherNumbers !== '' ) {
    lastThree = ',' + lastThree;
  }
  return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + afterPoint;
}


export function scrollTop () {
  const { scroller } = Scroll;
  // TODO handle this in a better way
  // currently using the raw api from react-scroll to enable smooth scrolling
  // Scroller needs a registered {name:element} to enable .scrollTo
  scroller.register('body', document.body);
  scroller.scrollTo('body', true/*shouldAnimate*/, 300/*duration in ms*/);
  scroller.unregister('body');
}

export function scrollToElementById () {
  // scrollToElement(elementID, {offset: -4, duration: 500});
}

export function getFileExtension (filename) {
    var parts = filename.split('.');
    return parts[parts.length - 1].toLowerCase();
}

export function removeTrailingSlash (input = '') {
  if (input.substring(input.length - 1) === '/') {
    return input.substring(0, input.length - 1);
  } else {
    return input;
  }
}

function pluckKeysFromObject (storeToStringify, keys) {
  if(!Array.isArray(keys)) {
    keys = [keys];
  }
  return keys.map(keyPath => {
    return { [keyPath]: storeToStringify[keyPath] };
  }).reduce((partialStoreObject, storeObject) => {
    partialStoreObject = { ...partialStoreObject, ...storeObject };
    return partialStoreObject;
  }, {});
}

export function stringifyKeys (object, keys) {
  return JSON.stringify(pluckKeysFromObject(object, keys));
}

export function closest(elem, attr) {
  if (!elem.parentElement) {
    return false;
  }
  if (elem.parentNode.getAttribute(attr)) {
    return true;
  }
  return closest(elem.parentNode, attr);
}

export function closestAttr(elem, attr) {
  if (!elem.parentElement) {
    return false;
  }
  if (elem.getAttribute(attr)) {
    return elem.getAttribute(attr);
  }
  if (elem.parentNode.getAttribute(attr)) {
    return elem.parentNode.getAttribute(attr);
  }
  return closestAttr(elem.parentNode, attr);
}

export function sanitizeHtmlInput (data, settings = {}) {
  // default tags, attributes, schemas etc to be allowed in the sanitized HTML output
  let defaultSettings = {
    allowedTags: ['p', 'div', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'a', 'em', 'strong', 'br', 'span', 'b', 'i'],
    allowedAttributes: { 'a': ['href', 'title'], 'img': ['src', 'alt', 'title'] },
    allowedSchemes: ['http', 'https'],
  };
  settings = { ...defaultSettings, ...settings };
  return sanitizeHtml(data, settings);
}

export function parseLinks (input = '') {
  return input.replace(/((http| ftp|https):\/\/)?[\w-@:]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#\-\(\)]*[\w@\)\(?^=%&amp;\/~+#-])?/gmi, function(foundURL){
    const linkURL = (foundURL.indexOf('://') === -1) ? `http://${foundURL}` : foundURL;
    return `<a target="_blank" rel="noreferrer" href="${linkURL}">${foundURL}</a>`;
  });
}
/*
 * http://stackoverflow.com/questions/18749591/encode-html-entities-in-javascript
*/
export function encodeString (input = '') {
  return input.replace(/[\u00A0-\u9999<>\&]/gim, (i) => (`&#${i.charCodeAt(0)};`));
}

export function getSelectedOptionLabel (e) {
  let selectNode = e.target;
  if (selectNode.selectedIndex === -1)
      return null;
  return selectNode.options[selectNode.selectedIndex].text;
}

export function arrayContains(a, obj) {
  return obj.indexOf(a) !== -1;
}

export function removeDuplicatesAndSortArray(inputArray = []) {
  return inputArray.sort().filter((item, pos, ary) => (!pos || item !== ary[pos - 1]));
}

export function getCurrentUTCTimestamp() {
  var newDate = new Date();
  return newDate.toUTCString();
}

export function isSessionStorageAvailable () {
  let isSessionStorageAvailable = true;
  try {
    sessionStorage.setItem('test', 'test');
  } catch (e) {
    isSessionStorageAvailable = false;
  }
  return isSessionStorageAvailable;
}

export function getFormattedDateWithCurrentDateDifference (dateString) {
  const givenDate = format(dateString, 'Do MMMM, YYYY');
  const dateDifferenceFromNow = distanceInWordsToNow(dateString, { includeSeconds: true, addSuffix: true });
  const dateDifferenceFromNowNoSuffix = distanceInWordsToNow(dateString, { includeSeconds: true });
  return {
    date: givenDate,
    difference: dateDifferenceFromNow,
    differenceNoSuffix: dateDifferenceFromNowNoSuffix,
  };
}

export const toTwoDecimalPlaces = (value) =>
  Math.round(value * 100) / 100;

export const decimalPlaces = function (value) {
  if (Math.floor(value) === value) {
    return 0;
  }
  try {
    return value.toString().split('.')[1].length || 0;
  } catch (e) {
    return 0;
  }
};

export function nullToEmptyString (obj) {
  return Object.keys(obj).reduce((o, k) => {
    if (obj[k] === null) {
      o[k] = '';
    } else {
      o[k] = obj[k];
    }
    return o;
  }, {});
}

export function stringCompare (str1, str2) {
  const string1 = str1.replace(/[^\w\s]/gi, '').toLowerCase();
  const string2 = str2.replace(/[^\w\s]/gi, '').toLowerCase();
  if (string1 > string2) {
    return 1;
  } else if (string1 < string2) {
    return -1;
  }
  return 0;
}

export function triggerEvent(el, type){
  if ('createEvent' in document) {
    // modern browsers, IE9+
    const e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
  } else {
    // IE 8
    const e = document.createEventObject();
    e.eventType = type;
    el.fireEvent('on' + e.eventType, e);
  }
}

export const hideDropdown = () => {
  const $body = document.querySelector('body');
  triggerEvent($body, 'click');
};

const userAgent = root.navigator.userAgent;

// https://stackoverflow.com/questions/24861073/detect-if-any-kind-of-ie-msie
export const isInternetExporerBrowser = (root.navigator.appName == 'Microsoft Internet Explorer' ||  !!( /Trident/.test(userAgent) || /rv:11/.test(userAgent) || /MSIE/g.test(userAgent) ));

export const isIOS_Device = /iPhone|iPad|iPod/i.test(userAgent);

export const isAndroidDevice = /android/i.test(userAgent);

export const isWindowsPhoneDevice = /Windows Phone/i.test(userAgent);

// Chrome/Firefox Browser have Safari in UserAgent String
export const isIOS_Webview = isIOS_Device && !(
  /Safari/i.test(userAgent) ||
  /Opera/i.test(userAgent) ||
  /OPR/.test(userAgent) ||
  /UCBrowser/i.test(userAgent)
);

export const isAndroidWebview = isAndroidDevice &&
  /Version\/[\d]{1}\.[\d]{1}/i.test(userAgent) && (
  /[ ]wv[ )]/i.test(userAgent) || !(
    /Opera/i.test(userAgent) ||
    /OPR\//.test(userAgent) ||
    /UCBrowser/i.test(userAgent)
  )
);

export const isSmallDevice = () => root.innerWidth < 640;

export const isRunningInIframe = () => root.parent !== root;



// WEBPACK FOOTER //
// ./src/common/config/utils.js